define(function(require, exports, module) {
    'use strict';

    const user = require('user');
    const config = require('config');

    module.exports = {
        notify: function() {
            var isSuspended = user.get('suspended');
            var webContent = isSuspended
                ? config.get('wcIdForSuspendedPlayer')
                : config.get('wcIdForNotSuspendedPlayer');

            window.Playtech.API.popup.showPopup({
                isModal: isSuspended,
                articleId: webContent,
                buttons: false,
                closeAll: true,
                layer: 'HIGH_PRIORITY'
            });
        }
    };
});
